import { render, staticRenderFns } from "./pos-addNewProduct.vue?vue&type=template&id=c61bf7ae"
import script from "./pos-addNewProduct.vue?vue&type=script&lang=js"
export * from "./pos-addNewProduct.vue?vue&type=script&lang=js"
import style0 from "./pos-addNewProduct.vue?vue&type=style&index=0&id=c61bf7ae&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports